import React, { PureComponent } from "react"
import qs from 'querystring';

import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Section from "../components/section"
import Carousel from "../components/carousel"

import bannerPng from "../images/business/banner.png"
import regionPng from "../images/business/map.png"
import partnerGNTPng from "../images/business/partner-gnt.png"
import partnerHXGKPng from "../images/business/partner-hxgk.png"
import partnerHXKJPng from "../images/business/partner-hxkj.png"
import partnerHXZSPng from "../images/business/partner-hxzs.png"
import partnerSMFPng from "../images/business/partner-smf.png"

import './business.css';
import "../components/tab-container.css"
import { productList } from "../data/productList";

class Page extends PureComponent {
  state = {
    activeIndex: 0,
    scrollPosition: 0,
  }

  onProductClick = index => {
    this.setState({ activeIndex: index })
  }

  componentDidMount () {
    const { search } = this.props.location;
    const newSearch = search.split('?')
    const params = qs.parse(newSearch[1]);
    const { product } = params;
    const productIndex = parseInt(product, 10);
    if (product) {
      this.setState({ activeIndex: productIndex })
    }
  }

  render() {
    const { activeIndex } = this.state;

    const productDetails = productList.map((it, index) => {
      const { imgSrc, detailImgSrc, title, desc } = it;
      return(
        <div key={index} style={{ display: activeIndex === index ? "block" : "none" }}>
          <div className="detailItem">
            <div className="detailImageSection">
              <div className="detailImgWrap">
                <img className="detailImg" src={imgSrc} alt={title}/>
              </div>
              { detailImgSrc && (
                <div className="detailImgWrap">
                  <img className="detailImg" src={detailImgSrc} alt={title} />
                </div>
              )}
            </div>
            <div className="detailInfo">
              <h5 className="detailTitle">{title}</h5>
              <p className="detailDesc">{desc}</p>
            </div>
          </div>
        </div>
      );
    });

    return(
      <Layout>
        <SEO title="业务体系" />
        <Banner image={bannerPng} />
        <Section>
          <div style={{ paddingTop: 30 }}>
            <div  className="content-wrapper" style={{ paddingBottom: 20 }}>
              <div className="content-header">
                <h3>产品介绍</h3>
              </div>
              <div className="content-main">
                <div className="detailWrap">
                  {productDetails}
                </div>
                <div className="productSliderContainer">
                  <Carousel 
                    images={productList} 
                    onImageClick={this.onProductClick} 
                    activeIndex={activeIndex} 
                  />
                </div>
              </div>
            </div>
            <div className="content-wrapper" style={{ paddingBottom: 20 }}>
              <div className="content-header">
                <h3>合作伙伴</h3>
              </div>
              <div className="content-main">
                <div className="partner">
                  <ul className="serverWrap">
                    <li>我们的客户</li>
                    <img src={regionPng} alt="服务区域" />
                    <p className="serverText">海华鑫安产品、方案已经广泛应用于国内30余个省/自治区/直辖市，<br/>服务体系覆盖全国三十多个省/自治区/直辖市</p>
                  </ul>
                  <ul>
                    <li>战略合作伙伴</li>
                    <div className="partnerWrap">
                      <img src={partnerGNTPng} alt="广州市高奈特网络科技有限公司" />
                      <img src={partnerHXGKPng} alt="北京海鑫高科指纹技术有限公司" />
                      <img src={partnerHXKJPng} alt="北京海鑫科金高科技股份有限公司" />
                      <img src={partnerHXZSPng} alt="北京海鑫智圣技术有限公司" />
                      <img src={partnerSMFPng} alt="赛默飞世尔" />
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Section>
      </Layout>
    )
  }
}

export default Page
